import { FC } from "react";
import BasicLayout from "../layouts/BasicLayout";
import { Outlet } from "react-router-dom";
import NewsList from "./views/NewsList";
import NewsComponent from "./views/NewsComponent";
import SidebarFunc from "../layouts/BasicLayout/SidebarFunc";

interface INewsRoute {
  loginData: any,
  permissions: any;
}

export const newsRoutes = [{ id: 1, path: "", component: <NewsComponent /> }];

const NewsRoute: FC<INewsRoute> = ({ loginData, permissions }) => {
  const data = loginData;
  var sidebarsData = SidebarFunc();
  return (
    <BasicLayout userData={data} permissions={permissions} sidebars={sidebarsData}>
      <div className="pt-0 pb-[58px]">
        <Outlet />
      </div>
    </BasicLayout>
  );
};

export default NewsRoute;
